import { type PrescriptionPrescriptionTypeEnum } from '@redteclab/api/clients/bully'

import { useGlobalConfigContext } from '../../../../../global-config'
import {
  type ProductDiscountBoundaries,
  productIsValidDiscount,
} from '../../../../../product'
import { priceAccessorGetDisplayPrice } from '../../../../model/priceAccessor/priceAccessorGetDisplayPrice'
import { productAccessorGetDiscountFromOffer } from '../../../../model/productAccessor/productAccessorGetDiscountFromOffer'
import { productAccessorGetOfferByIdOrDefault } from '../../../../model/productAccessor/productAccessorGetOfferByIdOrDefault'
import { type SelectionEntry } from '../../../product-page-context/AttributeGroup'

export const useSelectionSetAnyDiscountOrBonuses = ({
  currentPrescriptionType,
  discountBoundaries,
  isMarketplace,
  offerId,
  selectionEntries,
}: {
  currentPrescriptionType: PrescriptionPrescriptionTypeEnum
  discountBoundaries?: ProductDiscountBoundaries
  isMarketplace: boolean
  offerId: string | null
  selectionEntries: SelectionEntry[]
}): { hasAnyBonuses: boolean; hasAnyDiscounts: boolean } => {
  const { tenant } = useGlobalConfigContext()
  let hasAnyBonuses = false
  let hasAnyDiscounts = false

  selectionEntries.some((entry) => {
    const [currentVariant] = entry.allCandidateVariants

    const offer = productAccessorGetOfferByIdOrDefault({
      isMarketplace,
      offerId,
      offers: currentVariant.offers,
    })

    if (!offer) {
      return false
    }

    const displayPrice = priceAccessorGetDisplayPrice(
      offer,
      currentPrescriptionType,
    )

    const discount = productAccessorGetDiscountFromOffer({
      currentPrescriptionType,
      offer,
      tenant,
    })

    hasAnyBonuses ||= Boolean(displayPrice?.bonus)
    hasAnyDiscounts ||= Boolean(
      discount && productIsValidDiscount(discount, discountBoundaries),
    )

    return hasAnyBonuses && hasAnyDiscounts
  })

  return { hasAnyBonuses, hasAnyDiscounts }
}
